import api from '../index';

const set = instance => {
  if (instance) {
    try {
      api.defaults.headers.common['instance'] = instance;
    } catch (error) { }

    localStorage.setItem('instance', instance);
  } else {
    try {
      delete api.defaults.headers.common['instance'];
    } catch (error) { }
    if (localStorage?.instance) localStorage.removeItem('instance');
  }
};

export default set;
